<cmn-icon-button-base [icon]="icon"
                      [styleClass]="'app-icon-button orange'"
                      [disabled]="disabled"
                      [showSpinner]="showSpinner"
                      (action)="onAction($event)">
</cmn-icon-button-base>

